import styled from "@emotion/styled";
import {IndicatorColors} from "../../settings/ColorSettings/ColorizedIndicators/ColorizedIndicators";
import {ICellRendererParams} from "@ag-grid-community/core";
import {UserColor} from "../../settings/ColorSettings/ColorizedIndicators/types/indicatorLogicType";

export const ColorIndicatorCellRenderer = (props: ICellRendererParams<any, UserColor, any> & {minimal?: boolean}) => {
  const Container = props.minimal ? ColorIndicatorDivMinimal : ColorIndicatorDiv;
  return (
    <Container color={props.value && IndicatorColors[props.value] ? IndicatorColors[props.value].hex : ""}></Container>
  );
};

const ColorIndicatorDivMinimal = styled.div`
  height: 48px;
  width: 4px;
  border-radius: 2px;
  background: ${(props) => props.color};
`;

const ColorIndicatorDiv = styled.div`
  height: 39px;
  width: 8px;
  padding-left: 7px;
  border-radius: 3px;
  background: ${(props) => props.color};
`;
